//Función para extraer el array con los datos de la Empresa en base a su Id y almacenar
// en el localStorage el array con las rutas permitidas en base al Id de la Empresa.
export const changeEmpresa = (idEmpresa) => {
    // Obtener el objeto userData del localStorage.
    let userData = JSON.parse(localStorage.getItem('userData'));
    
    localStorage.setItem("idEmpresa", idEmpresa); //Guardar el id de la empresa en el localStorage.
    //console.log("Empresa: ",idEmpresa)
    
    // Verificar si userData y userData.Empresas existen.
    if (userData && userData.Empresas) {

        // Filtrar las empresas basadas en el idEmpresa proporcionado.
        let authPermiso = userData.Empresas.filter(permiso => permiso.IdEmpresa === idEmpresa);
        //console.log('La empresa seleccionada es: ', authPermiso);

        //Guardar dentro del localStorage los datos de la Empresa con los permisos.
        localStorage.setItem('empresaData', JSON.stringify(authPermiso));

        //Guardar dentro del localStorage los datos de los permisos.
        localStorage.setItem('permisos', JSON.stringify(authPermiso[0].Permisos.map(permiso => permiso.Path)));
        //console.log('Estas son las rutas permitidas', authPermiso[0].Permisos.map(permiso => permiso.Path));
        
        return authPermiso; // Retornar la empresa filtrada.
    } else {
        console.error('Error al obtener userData o userData.Empresas desde localStorage.');
        return null;
    }
};

